module.exports = __webpack_public_path__ + "img/3x.45ae1cb.jpg";